import styled from "styled-components";

export const DimensionList = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 2.4rem;
  gap: 0.8rem;
`;
